window.ttx = window.ttx || {};
ttx.loader = {};

ttx.loader.load = function (type, data, callback) {
    if (type == 'bill') {
        ttx.loader.createUIDOM(data.tplId, function (template) {
            ttx.loader.loadBill(data.billId, function (bill) {
                ttx.loader.render(template, bill, callback);
            });
        });
    }
};
ttx.loader.createUIDOM = function (params, callback, failCallback) {
    ttx.ajax.xhrUtil({
        url: '/api/meta/detail',
        method: 'post',
        data: params,
        success: (res) => {
            callback(res.data)
        },
        // meta 加载失败必须通知调用方（如 voucher.init 隐藏 loading），否则页面永久卡 loading
        error: (err) => {
            ttx.log.error('[ttx.loader] createUIDOM meta 加载失败', err);
            if (typeof failCallback === 'function') failCallback(err);
        }
    })

};
ttx.loader.loadBill = function (billId, callback) {
    ttx.ajax.get('/api/bill/' + billId, function (data) {
        callback(data);
    });

};
ttx.loader.render = function (template, bill, callback) {
    // 渲染单据

};
ttx.loader.openBill = function (props, type, mode, data, callback) {
    // mode 卡片页面专有参数 1. 新增 2.编辑 3.查看 4.打印
    let bill = {};
    if (data && Array.isArray(data)) {
        bill = ttx.utils.arrayToObj(data);
    } else {
        bill = data;
    }
    ttx.ajax.xhrUtil({
        url: '/api/bill/open',
        method: 'post',
        data: bill,
        success: (res) => {
            if (!res.data) {
                return
            }
            const { id, type } = res.data;
            // type 用于区分meta类型 1.list 2.detail 3.联查页面  4.模态框页面 5.其他页面 【iframe】
            let path = res.data.path + `?metaid=${id}&type=${type}&mode=${mode}`;
            if (mode != 1) {
                path = path.replace('add', data.id);
            }

            switch (type) {
                case 1:
                    props.match(path);
                    break;
                case 2:
                    props.match(path);
                    break;
                case 3:
                    props.match(path);
                    break;
                case 4:
                    let win = ttx.loader.openFloat(props, type, res.data, path, callback);
                    window.floatWin = win
                    break;
                case 5:
                    props.match(path);
                    break;

                default:
                    break;
            }
        }
    })
};
ttx.loader.openFloat = function (props, type, data, path, callback) {
    const iframe = document.createElement('iframe');
    iframe.src = path;
    iframe.style.cssText = `width:100%;height:100%;border:none;`;
    const win = ttx.loader.createFloatWin('浮窗', document.body.offsetWidth - 24 * 2, document.body.offsetHeight - 24 * 2, 24, 24, iframe, () => {
        // this._floatWin = null;
    });
    // window.floatWin=win

    // 如果你想让子页面通知关闭，可以 postMessage
    window.addEventListener('message', (e) => {
        if (e.data && e.data.type === 'CLOSE_FLOAT_DETAIL') {
            win.el.querySelector('button:last-child')?.click();
        }
    }, { once: true });
    return win;
};

ttx.loader.closeWin = function () {
    if (!window.parent.floatWin) return
    window.parent.floatWin.close();
};

ttx.loader.createFloatWin = function (title = '浮窗',
    width = 420,
    height = 520,
    x = 24,
    y = 24,
    content, // HTMLElement 或 string
    onClose) {
    const root = document.createElement('div');
    root.style.cssText = `
    position: fixed;
    left: ${x}px; top: ${y}px;
    width: ${width}px; height: ${height}px;
    z-index: 2147483647;
    border: 1px solid rgba(0,0,0,.12);
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 40px rgba(0,0,0,.18);
    overflow: hidden;
    user-select: none;
    `
    const header = document.createElement('div');
    header.style.cssText = `
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
     background: rgba(0,0,0,.03);
    cursor: grab;
`;

    const name = document.createElement('div');
    name.textContent = title;
    name.style.cssText = `font-size: 14px; font-weight: 600;`;

    const actions = document.createElement('div');
    actions.style.cssText = `display:flex; gap:8px;`;

    const btn = (text) => {
        const b = document.createElement('button');
        b.textContent = text;
        b.style.cssText = `
        height: 28px; padding: 0 10px;
        border-radius: 8px;
        border: 1px solid rgba(0,0,0,.12);
        background: #fff;
        cursor: pointer;
        user-select: none;
        `;
        return b;
    };

    const minBtn = btn('—');
    const closeBtn = btn('×');

    actions.appendChild(minBtn);
    actions.appendChild(closeBtn);

    header.appendChild(name);
    header.appendChild(actions);

    const body = document.createElement('div');
    body.style.cssText = `
    height: calc(100% - 44px);
    overflow: auto;
    user-select: text;
`;

    if (typeof content === 'string') {
        body.innerHTML = content;
    } else if (content instanceof HTMLElement) {
        body.appendChild(content);
    } else {
        body.innerHTML = `<div style="padding:12px;color:#666;">空的…你没塞内容</div>`;
    }

    root.appendChild(header);
    root.appendChild(body);
    document.body.appendChild(root);

    // 拖拽
    let dragging = false;
    let startX = 0, startY = 0, startL = 0, startT = 0;

    const onDown = (e) => {
        dragging = true;
        header.style.cursor = 'grabbing';
        startX = e.clientX;
        startY = e.clientY;
        startL = root.offsetLeft;
        startT = root.offsetTop;
        root.style.opacity = '0.98';
    };

    const onMove = (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        // 简单防出屏幕，别拖没了
        const maxL = window.innerWidth - root.offsetWidth;
        const maxT = window.innerHeight - 60; // 留个头
        const l = Math.min(Math.max(0, startL + dx), Math.max(0, maxL));
        const t = Math.min(Math.max(0, startT + dy), Math.max(0, maxT));

        root.style.left = l + 'px';
        root.style.top = t + 'px';
    };

    const onUp = () => {
        if (!dragging) return;
        dragging = false;
        header.style.cursor = 'grab';
        root.style.opacity = '1';
        // 记一下位置，用户下次打开别乱跳
        try {
            localStorage.setItem('floatWin:lastPos', JSON.stringify({
                left: root.style.left, top: root.style.top,
                width: root.style.width, height: root.style.height,
            }));
        } catch (_) { }
    };

    header.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);

    // 最小化：缩成一条
    let minimized = false;
    const saved = { w: root.style.width, h: root.style.height };
    minBtn.onclick = () => {
        minimized = !minimized;
        if (minimized) {
            saved.w = root.style.width;
            saved.h = root.style.height;
            root.style.height = '44px';
            body.style.display = 'none';
            minBtn.textContent = '□';
        } else {
            root.style.width = saved.w;
            root.style.height = saved.h;
            body.style.display = 'block';
            minBtn.textContent = '—';
        }
    };

    closeBtn.onclick = () => {
        header.removeEventListener('pointerdown', onDown);
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        root.remove();
        onClose?.();
    };

    return {
        el: root,
        setTitle(t) { name.textContent = t; },
        setContent(node) {
            body.innerHTML = '';
            body.appendChild(node);
        },
        close() {
            header.removeEventListener('pointerdown', onDown);
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            root.remove();
            onClose?.();
        },
    };
};

ttx.loader.getCurrentWin = function () {
    if (!window.parent.floatWin) return null;
    return window.parent.floatWin;
};


const preLoadByBillNo = async function (viewmodel, data) {
};

ttx.loader.runCommandLine = async function (commend, data, viewmodel, callback) {
    switch (commend) {
        case 'menu': {
            break;
        }
        case 'bill': {
            preLoadByBillNo(viewmodel, data);
            ttx.loader.byBillNo(data, viewmodel, callback);
            break;
        }
        case 'add':
        case 'save':
        case 'delete':
        case 'submit':
        case 'approve':
        case 'reject':
        case 'edit':
        case 'cancel':
        case 'refresh':
        case 'print':
        case 'export':
            // 委托给命令系统执行
            ttx.command.execute(commend, { vm: viewmodel, params: data, callback });
            break;
        default: {
            // 如果 commend 是对象（button直接传入），尝试从对象中提取 command
            if (typeof commend === 'object' && commend.command) {
                ttx.command.execute(commend.command, { button: commend, params: data, vm: viewmodel, callback });
            }
            break;
        }
    }
}

ttx.loader.asyncByBillNo = async function (data, viewmodel, callback) {
    return new Promise((resolve, reject) => {
        ttx.loader.byBillNo(data, viewmodel, callback, resolve)
    })
}
/**
 * 打开单据并在当前页面显示
 *
 * data 结构：
 *   {
 *     billtype: 'Voucher',      // 单据类型（必填）
 *     billno: 'st_purinrecord', // 单据号（必填）
 *     domainKey: 'ustock',      // 领域编码
 *     busiObj: '',              // YPD框架需要：目标跳转单据业务对象编码，默认 null
 *     newOpenTabs: true,        // 是否新开系统级页签（多标签开关）。未传时按 mode 兜底：mode='add' 默认 true，其他默认 false；业务方可显式传 true/false 覆盖
 *     params: {
 *       mode: 'add',            // 模式：add（新增）/ edit（编辑） / browse（浏览）
 *       id: 'add',              // 新增时传 'add'，编辑/浏览时传目标单据 id
 *       query: {                // metaid 用于加载页面元数据，processParams 可自动补充
 *         appCode: '001',
 *         serviceCode: 'service01',
 *         metaid: 'xxx'
 *       }
 *     }
 *   }
 *
 * viewModel：父级 VM（可选），会被缓存为 parentViewModel，供 prevBill/nextBill 使用
 */
ttx.loader.byBillNo = async function (data, viewmodel, callback, resolve) {
    if (!data.billtype || !data.billno) return;
    // newOpenTabs：是否新开系统级页签（系统级多标签开关）。
    // - 业务方显式传 true/false：尊重业务方
    // - 未传：按 mode 兜底——mode='add'（新增→卡片）默认 true，其他默认 false（保持原页签栈行为）
    if (data.newOpenTabs === undefined) {
        var _mode = data?.params?.mode;
        var fromSystemTab = viewmodel?.getCache?.('newOpenTabs');
        data.newOpenTabs = (_mode === 'add') || !!fromSystemTab;
    }
    // 把 newOpenTabs 同步到 data.params 上，方便下游 callback 拿到
    // （业务方 callback 里调 portalactions.addItem 时，拦截器读 data.params.newOpenTabs）
    if (data.params && data.params.newOpenTabs === undefined) {
        data.params.newOpenTabs = data.newOpenTabs;
    }
    // if (!cb.events.execute('beforeLoadBillNo', data)) return;
    let params = await ttx.extend.processParams(data.params);
    // 透传 extraConfig（侧滑抽屉等配置）到 VM
    if (data.extraConfig) params.extraConfig = data.extraConfig;
    // YPD框架需要的业务对象编码，注入到 params 中供 voucher.init 使用
    params.busiObj = data.busiObj || null;
    // MDF 参数对齐：补齐 readOnly / serviceCode / carryData / carryParams
    // - readOnly：页面只读模式（透传到目标 VM）
    // - serviceCode：服务编码，用于路由到对应微服务
    // - carryData：覆盖业务 add 默认数据
    // - carryParams：额外携带参数（透传到目标页面 params）
    if (data.params) {
        if (data.params.readOnly !== undefined) params.readOnly = data.params.readOnly;
        if (data.params.serviceCode) params.serviceCode = data.params.serviceCode;
        if (data.params.carryData) params.carryData = data.params.carryData;
        if (data.params.carryParams) params.carryParams = data.params.carryParams;
    }
    // 顶层 domainKey 注入到 params，供下游 voucher.init / rest 请求使用（MDF: params.domainKey 必传）
    if (data.domainKey && !params.domainKey) params.domainKey = data.domainKey;
    // if (data.params && data.params.menuUrl && !data.params.query) {
    //     const queryString = new ttx.utils.queryString(data.params.menuUrl);
    //     data.params.query = queryString.query;
    // }
    // cb.utils.loadingControl.start();

    const billType = data.billtype.toLowerCase()
    const bill = ttx.models.getBizModel(billType);

    if (billType && params) {
        await bill.init(data.billno, params, async function (vm, viewmeta, title) {
            // 将父级 VM 缓存在新 VM 上，供 prevBill/nextBill 等命令使用
            if (viewmodel) {
                vm.setCache?.('parentViewModel', viewmodel);
            }
            // newOpenTabs 缓存不在这里设置，统一由 core 侧 Pane render 负责：
            // Pane render 只在系统级标签的根 VM（panes[0]）上设置该缓存，
            // 内部栈内的子 VM 不会有此缓存，back 时走 requestClose 正常弹栈
            if (vm && data.params) {
                vm.setCache?.('_openParams', data.params);
            }
            // 加载模板扩展脚本（通过 metaId 查询页面关联的模板脚本，执行并调用 init）
            var metaId = params?.query?.metaid || viewmeta?.id;
            ttx.log.info('[ttx.loader] byBillNo metaId=' + metaId + ', billno=' + data.billno);
            if (metaId) {
                await ttx.script.loadPageScripts(metaId, vm);
            } else {
                ttx.log.warn('[ttx.loader] byBillNo 未获取到 metaId，跳过脚本加载');
            }
            return new Promise(async (resolve) => {
                if (typeof callback === 'function') {
                    // 正常流程：SDK 命令回调中处理 addItem 等逻辑
                    callback(vm, viewmeta, title);
                } else if (params.templateType === 'modal') {
                    // 无回调的 modal/抽屉打开（如控制台直接调用），自动 addItem 带 delay
                    // extraConfig._innerType 区分模态框（默认）和侧滑抽屉（'fadeRightToLeft'）
                    var view = (viewmeta?.view || viewmeta?.template?.view) || {};
                    ttx.portalactions.addItem(data.billno, {
                        // 标题优先级：打开参数显式指定 > 页面名称
                        title: params.title || view.pageName || title || '',
                        content: { vm: vm, metaData: viewmeta, delay: true, extraConfig: params.extraConfig || {} },
                    });
                }
                resolve(vm, viewmeta, title);
            });
        }, function (params) {

        })
    } else {
        // @ts-ignore
        ttx.console.error(Error.E00001, `cb.loader.byBillNo:billtype:${billType} 不存在`);// @notranslate
    }
};

// ============================================================
// MDF Page/Loader API 补齐
// ============================================================

// 注意：ttx.loader.loadResourceByDomain / ttx.loader.loadDomainResource
// 已在 tx.extend.js 中实现（签名 (domainKey, params)，内部走 loadExtend / getLoginUser），
// 此处不再重复定义，避免覆盖现有实现。
//   - loadResourceByDomain：未登录调用，仅加载前端扩展资源
//   - loadDomainResource  ：登录后调用，加载扩展 + getLoginUser

/**
 * 便捷打开页面方法，封装 runCommandLine
 * 对应 MDF cb.loader.openPage
 * @param {object} options 打开页面配置
 *   { billtype, billno, mode, id, domainKey, templateType, carryParams, query, newOpenTabs, serviceCode, busiObj, readOnly, carryData }
 * @param {object} [parentVM] 父级 ViewModel
 * @param {function} [callback] 打开完成回调
 */
ttx.loader.openPage = function (options, parentVM, callback) {
    var opts = options || {};
    if (!opts.billtype || !opts.billno) {
        ttx.console.error('[ttx.loader.openPage] billtype/billno 必传');
        return;
    }
    // 组装 runCommandLine 所需的 data 结构
    var data = {
        billtype: opts.billtype,
        billno: opts.billno,
        domainKey: opts.domainKey,
        busiObj: opts.busiObj,
        newOpenTabs: opts.newOpenTabs,
        params: {
            mode: opts.mode,
            id: opts.id,
            templateType: opts.templateType,
            query: opts.query,
            serviceCode: opts.serviceCode,
            readOnly: opts.readOnly,
            carryData: opts.carryData,
            carryParams: opts.carryParams
        }
    };
    // 过滤 undefined 字段，避免覆盖默认逻辑
    Object.keys(data).forEach(function (k) { if (data[k] === undefined) delete data[k]; });
    if (data.params) {
        Object.keys(data.params).forEach(function (k) { if (data.params[k] === undefined) delete data.params[k]; });
    }
    return ttx.loader.runCommandLine('bill', data, parentVM, callback);
};

/**
 * 返回上一页，等价 viewmodel.execute('back')
 * 对应 MDF cb.loader.back
 * @param {object} viewmodel 当前页面 ViewModel
 */
ttx.loader.back = function (viewmodel) {
    if (!viewmodel || typeof viewmodel.execute !== 'function') {
        ttx.console.warn('[ttx.loader.back] viewmodel 无效');
        return;
    }
    return viewmodel.execute('back');
};

/**
 * 刷新页面，等价 viewmodel.execute('refresh')
 * 对应 MDF cb.loader.refresh
 * @param {object} viewmodel 当前页面 ViewModel
 */
ttx.loader.refresh = function (viewmodel) {
    if (!viewmodel || typeof viewmodel.execute !== 'function') {
        ttx.console.warn('[ttx.loader.refresh] viewmodel 无效');
        return;
    }
    return viewmodel.execute('refresh');
};
